<template>
    <div class="favourite">
        <div class="title">{{$t('text.favourite')}}
            <div class="editBtn" @click="changeEdit">{{!isEdit?$t('text.edit'):$t('text.finish')}}</div>
            <div class="back" @click="$router.go(-1)">
                <van-icon name="arrow-left" />
            </div>
        </div>
        <div class="tabs">
            <van-tabs type="card"  v-model:active="typeId" :ellipsis="false"  @change="onClickTab">
                <van-tab v-for="item in courseBtnList" :key="item.title" :name="item.value" :title="item.title"></van-tab>
            </van-tabs>
        </div>
        <div :class="['historyList',isEdit?'lsHasEdit':'']">

            <div class="courseList">

                <div class="course" v-for="(e,i) in courseList" :key="i">
                    <div class="choose-item" :class="[{ 'is-chose': e.checked }]" @click="handlerCheck(i)" v-show="isEdit">
                        <!-- <img v-if="allChose" src="@/assets/img/selected.png" /> -->
                        <img v-show="e.checked" src="@/assets/img/selected.png" />
                        <!-- <img v-show="!e.checked" src="@/assets/img/unselected.png" /> -->
                    </div>
                    <!-- <van-checkbox checked-color="#ee0a24"></van-checkbox> -->
                    <div class="courseLeft">
                        <van-image :src="$utils.setSourcePath(e.preview)">
                            <span>{{e.date || '2025-07-16'}}</span>
                        </van-image>
                        
                    </div>
                    <div :class="['courseRight',!isEdit?'':'radioWidth']">
                        <div class="title ellipsis">{{ e.title }}</div>
                        <div class="tag">{{e.typeName}}</div>
                        <div class="timeBtn">
                            <span>{{e.length}}{{$t('business_school.min')}}</span>
                            <sd-button mini2 @click.native="toPage('/learn-detail',{id: e.id})">{{$t('text.learn')}}</sd-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot" v-show="isEdit">
            <div class="selectAll">
                {{$t('business_school.selected_all')}}　
                
                    <div class="choose-item" :class="[{ 'is-chose': allChecked }]" @click="handlerAllCheck">
                        <img v-show="allChecked" src="@/assets/img/selected.png" />
                    </div>
                    <!-- <van-checkbox v-show="isEdit" @click.native="handlerAllCheck" :value="checked" checked-color="#ee0a24"></van-checkbox> -->
            </div>
            <sd-button class="reset" @click.native="reset" plain>{{$t('text.reset')}}</sd-button>
            <sd-button class="remove" @click.native="remove" mini>{{$t('business_school.removed')}}({{ listCheckLength() }})</sd-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "cases",
    components: {  },
    data() {
        return {
            typeId: '',
            allChecked: false,
            isEdit: false,
            courseBtnList: [],
            courseList: [],
        }
    },

    computed: {
        
    },
    watch: {
        caregry:{
            handler(val,oldVal){
                
                if (val==='annual') {
                    this.columns = [
                    { text: '2021年', value: 2021 },
                    { text: '2022年', value: 2022 },
                    { text: '2023年', value: 2023 },
                    { text: '2024年', value: 2024 },
                    { text: '2025年', value: 2025 },
                    ]
                } else {
                    
                    this.columns = [
                    { text: 'January', value: 1 },
                    { text: 'February', value: 2 },
                    { text: 'March', value: 3 },
                    { text: 'April', value: 4 },
                    { text: 'May', value: 5 },
                    { text: 'June', value: 6 },
                    { text: 'July', value: 7 },
                    { text: 'August', value: 8 },
                    { text: 'September', value: 9 },
                    { text: 'October', value: 10 },
                    { text: 'November', value: 11 },
                    { text: 'December', value: 12 },
                    ]
                }
            },
            immediate:true
        }
    },

    created() {
        this.getData()
        this.getCourseTypeList()
    },

    methods: {
        getCourseTypeList() {
            this.$apis.school.getCourseTypeList().then(res => {
                this.courseBtnList = res.data.list.map(item => {
                    return {
                        title: item.typeName,
                        value: item.id
                    }
                })
                this.courseBtnList.unshift({ title: this.$t('text.all'), value: '' });
            }).catch(err => {
                console.error(err)
            })
        },
        getData(){
            this.$apis.school.getCourseFavList({typeId: this.typeId}).then(res=>{
                this.courseList = res.data.list.map(item => {
                    return {
                        ...item,
                        date: item.updateTime.split(' ')[0],
                        checked: false, // 添加checked属性用于编辑状态
                    }
                })
                console.log(this.courseList);
                
            })
        },
        listCheckLength(){
            const listLength = this.courseList.filter(item=>item.checked)
            return listLength.length
        },
        handlerAllCheck(){
            this.courseList.forEach(item=>{
                item.checked = !this.allChecked
            })
            this.allChecked = !this.allChecked
        },
        handlerCheck(i){
            console.log(this.courseList[i]);
            
            this.courseList[i].checked = !this.courseList[i].checked
        },
        reset(){
            this.courseList.forEach(item=>{
                item.checked = false
            })
            this.allChecked = false
        },
        remove(){
            const courseIds = this.courseList.filter(item => item.checked).map(item => item.id).join(',')
            if (courseIds.length === 0) return this.$toast(this.$t('business_school.please_select_at_least_one_course_to_remove'));
            this.$apis.school.courseFav({courseId: courseIds}).then(res => {
                this.$toast(this.$t('business_school.removed_successfully'))
                this.getData()
            }).catch(err => {
                console.error(err)
            })
            // const promiseAll = this.courseList.filter(item=>item.checked).map(item=>{
            //     return this.$apis.school.courseFav({courseId: item.id})
            // })
            // Promise.all(promiseAll).then(res=>{
            //     this.$toast('Removed successfully')
            //     this.getData()
            // }).catch(err => {
            //     console.error(err)
            // })
            // this.courseList = this.courseList.filter(item=>!item.checked)
        },
        changeEdit(){
            this.isEdit = !this.isEdit
        },
        onClickTab(){
            console.log(this.typeId);
            this.getData()
        },
        toPage(path, query) {
            this.$router.push({
                path, query
            })
        },
    },

    beforeDestroy() {
    }
}
</script>

<style lang="scss">
.favourite {
    background: #F4F5F8;
    height: 100%;
    overflow: auto;
    font-size: 14px;
    font-weight: bold;
    .title{
        background-color: #fff;
        font-size: 16px;
        height: 50px;
        line-height: 50px;
        .back{
            position: absolute;
            top: 0;
            left: 0;
            margin-left: 10px;
        }
        .editBtn{
            position: absolute;
            right: 0;
            top: 0;
            margin-right: 10px;
            color: #ee0a24;;
        }
    }
    .van-tabs__nav--card{
        border: none;
    }
    .tabs{
        width: 100%;
        height: 60px;
        overflow: auto;
        display: flex;
        align-items: center;
        &::-webkit-scrollbar {
          display: none;
        }
        .van-tabs{
            // overflow: auto;
            .van-tabs__wrap {
                overflow: inherit;
                .van-tabs__nav{
                    // overflow: auto;
                    height: 30px;
                }
            }
        }
        .van-tabs__nav{
            background: #F4F5F8;
            .van-tab{
                font-size: 14px;
                background: #fff;
                color: #666;
                border-radius: 10px;
                border: none;
                margin-right: 10px;
                // padding: 10px;
                // height: 30px;
            }
            .van-tab--active{
                color: #fff;
                background: #ee0a24;
            }
        }
    }
    .historyList{
        width: 100%;
        overflow: auto;
        height: calc(100% - 110px);
        &::-webkit-scrollbar {
          display: none;
        }
        .courseList{
            margin: 10px;
            width: calc(100% - 20px);
            .name{
                font-size: 16px;
                text-align: left;
            }
            .course{
                box-sizing: border-box;
                width: 100%;
                display: flex;
                padding: 10px;
                border-radius: 5px;
                background: #fff;
                margin-top: 20px;
                align-items: center;
                .choose-item{
                    width: 20px;
                    height: 20px;
                    border: 2px solid #aeb2b8;
                    box-sizing: border-box;
                    border-radius: 50%;
                }
                .courseLeft{
                    .van-image{
                        width: 150px;
                        height: 100px;
                        span{
                            background: rgba(0,0,0,.4);
                            padding: 2px;
                            color: #fff;
                            border-radius: 4px;
                            position: absolute;
                            bottom: 0;
                            min-width: 40px;
                            left: 4px;
                            bottom: 4px;
                            font-weight: normal;
                        }
                    }
                }
                .radioWidth{
                    width: calc(100% - 180px) !important;
                }
                .courseRight{
                    width: calc(100% - 150px);
                    .title{
                        text-align: left;
                        text-indent: 5px;
                    }
                    .tag{
                        font-weight: normal;
                        display: inline-block;
                        padding: 4px;
                        border-radius: 4px;
                        color: #636872;
                        background: #e6e7ea;
                        float: left;
                        margin-left: 10px;
                    }
                    .timeBtn{
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 10px;
                        box-sizing: border-box;
                        .main-block{
                            width: 80px;
                            height: 30px;
                        }
                    }
                }
            }

        }
    }
    .lsHasEdit{
        height: calc(100% - 150px) !important;
    }
    .foot{
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        background-color: #fff;

        .selectAll{
            height: 100%;
            // width: 30%;
            height: 30px;
            display: flex;
            align-items: center;
            .choose-item {
                width: 20px;
                height: 20px;
                border: 2px solid #aeb2b8;
                box-sizing: border-box;
                border-radius: 50%;
            }
        }
        .reset{
            height: 100%;
            height: 30px;
            width: 20%;
        }
        .remove{
            height: 100%;
            width: 30%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/school/favourite.vue